
























import { Vue, Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { Student } from '@/models/student/student';
import { GPageBase } from '@/mixins';

@Component({
  name: 'GJgrowEventCreateExamineeStudentTable',
  computed: {},
  methods: {},
})
export default class GJgrowEventCreateExamineeStudentTable extends Mixins(GPageBase) {
  pageSize: number = 10;
  currentPage: number = 1;
  studentListColumn: any[] = [];

  @Prop({ default: (): Student[] => [] }) students: Student[];
  @Prop({ default: false })
  isStudentLoading: boolean;
  @Prop({ default: false })
  isConfirm: boolean;

  @Watch('isStudentLoading')
  watchIsStudentLoading(value: boolean) {
    this.isRunning = value;
  }

  mounted() {
    this.createColumn();
  }

  isAlreadyAssignedStudent(student: Student): boolean {
    return jgrowEventCreateModule.alreadyAssignedStudentIDs.has(student.studentID);
  }

  get selectedStudentsByPage() {
    const offset: number = (this.currentPage - 1) * this.pageSize;
    const limit: number = this.currentPage * this.pageSize;

    return this.students.slice(offset, limit);
  }

  get columnClass() {
    return {
      title: 'クラス',
      key: 'schoolClass',
      sortable: false,
      width: 200,
      align: 'center',
      render: (h: any, params: any) => {
        const rowStudent: Student = params.row;
        const selectedRow: Student = this.students.find((student: Student) => student.studentID === rowStudent.studentID);
        return h(
          'Tooltip',
          {
            props: {
              content: selectedRow.schoolClass.schoolClassNameWithGrade,
              placement: 'right',
              ['max-width']: 200,
              disabled: !this.isOverLength(selectedRow.schoolClass.schoolClassNameWithGrade, 20),
            },
          },
          [h('span', {}, this.simpleText(selectedRow.schoolClass.schoolClassNameWithGrade, 20))]
        );
      },
    };
  }

  get columnStudentNumber() {
    return {
      title: 'ログインID',
      key: 'studentNumber',
      sortable: false,
      width: 200,
      align: 'center',
    };
  }

  get columnName() {
    return {
      title: '氏名',
      key: 'fullName',
      sortable: false,
      align: 'center',
      render: (h: any, params: any) => {
        const rowStudent: Student = params.row;
        const selectedRow: Student = this.students.find((student: Student) => student.studentID === rowStudent.studentID);
        return h(
          'Tooltip',
          {
            props: {
              content: selectedRow.fullName,
              placement: 'bottom',
              ['max-width']: 200,
              disabled: !this.isOverLength(selectedRow.fullName, 30),
            },
          },
          [h('span', {}, this.simpleText(selectedRow.fullName, 30))]
        );
      },
    };
  }

  get columnDeleteButton() {
    return {
      title: '',
      slot: 'delete',
      align: 'center',
    };
  }

  handlePagerChange(nextPage: number) {
    this.currentPage = nextPage;
  }

  createColumn() {
    this.studentListColumn = [this.columnClass, this.columnStudentNumber, this.columnName];
    if (!this.isConfirm) {
      // 編集画面では対象者除外ボタンを表示する
      this.studentListColumn.push(this.columnDeleteButton);
    }
  }

  rowClassName(row: Student): string {
    if (row.selected) {
      return 'disable-row';
    } else if (this.isAlreadyAssignedStudent(row)) {
      return 'already-assigned-row';
    }
  }

  deleteButtonType(selected: boolean): string {
    if (selected) {
      return 'success';
    }
    return 'error';
  }

  handleDeleteSelectedStudent(targetStudent: Student) {
    const deleteStudentIndex: number = this.students.findIndex((student: Student) => student.studentID === targetStudent.studentID);
    jgrowEventCreateModule.toggleSelectForStudents(deleteStudentIndex);
  }
}
